import React, { useEffect } from 'react'
import LottieAnimation from '../../../shared/lottie_animation'
import animation from '../../../../../assets/animations/loading.json'
import PropTypes from 'prop-types'

const GgGolfHubPopupNotification = ({
  isOpen,
  onClose,
  animationData = animation,
  text,
  autoCloseDelay = 2000,
}) => {
  useEffect(() => {
    if (!isOpen || !autoCloseDelay || !onClose) { return }
    const timer = setTimeout(onClose, autoCloseDelay)
    return () => clearTimeout(timer)
  }, [isOpen, autoCloseDelay, onClose])

  // Only a click on the overlay itself closes the popup; clicks bubbling up
  // from the popup body have a different target and are ignored.
  const onOverlayClick = (event) => {
    if (!onClose || event.target !== event.currentTarget) { return }
    onClose()
  }

  if (!isOpen) { return null }
  return (
    <div className='gg-golf-hub-overlay' onClick={onOverlayClick}>
      <div className='popup'>
        <div className='header simple-popup'>
          <button className='close-button' onClick={onClose} aria-label={window.I18n.t('gg_golf_hub.dashboard.close')}>
            <i className='fa-regular fa-xmark' aria-hidden='true'></i>
          </button>
        </div>
        <div className='body simple'>
          <LottieAnimation
            animationData={animationData}
            speed={2}
          />
          <div className='simple-bottom-text'>
            {text}
          </div>
        </div>
      </div>
    </div>
  )
}

GgGolfHubPopupNotification.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  animationData: PropTypes.object,
  text: PropTypes.string,
  autoCloseDelay: PropTypes.number,
}

export default GgGolfHubPopupNotification
